import {Chip, IconButton, Tooltip, Typography} from "@material-tailwind/react";
import React, {useContext, useState} from "react";
import {ServiceContext} from "../../context/service";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import {TableHead} from "../system/thead";
import {PencilIcon} from "@heroicons/react/24/solid";
import Dict from "../../helper/dict";


const TABLE_HEAD = ["#", "عنوان", "هزینه", "آخرین ویرایش", "وضعیت", "به‌روزرسانی", "عملیات"];

export function PersonServiceSideCostGrid() {

  const {
    setModalOpen,
    setStep,
    sideCosts,
    setSideCost,
  } = useContext(ServiceContext);

  const [selectedHead, setSelectedHead] = useState("#")

  const headMap = {
    "#": "id",
    "عنوان": "title",
    "هزینه": "cost",
    "آخرین ویرایش": "last_action",
    "وضعیت": "status",
    "به‌روزرسانی": "updated_at",
    "عملیات": "",
  }

  const headSortable = {
    "عنوان": false,
    "هزینه": false,
    "آخرین ویرایش": false,
    "وضعیت": false,
    "به‌روزرسانی": false,
    "عملیات": false,
  }

  return (<div>
    <table className="mt-4 text-left w-full">
      <TableHead
        tableHead={TABLE_HEAD}
        headSortable={headSortable}
        headMap={headMap}
        selectedHead={selectedHead}
        setSelectedHead={setSelectedHead}
      />
      <tbody className="textCenter">
      {sideCosts.map(({
                        id,
                        service_id,
                        title,
                        description,
                        cost,
                        last_action,
                        action_person_id,
                        file,
                        status,
                        updated_at,
                      }, index) => {

        const isLast = index === sideCosts.length - 1;
        const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

        return (<tr key={id}>

          <td className={classes}>
            <div className="flex justify-center px-4">
              <Typography color="blue-gray" className="textRight">
                {persianNumberFormat(index + 1, true)}
              </Typography>
            </div>
          </td>

          <td className={`${classes}`}>
            <div className="flex justify-center px-4">
              <Typography color="blue-gray" className="textRight">
                {title}
              </Typography>
            </div>
          </td>

          <td className={classes}>
            <div className="flex justify-center px-4">
              <Typography color="blue-gray" className="textRight">
                {persianNumberFormat(cost, true)}
              </Typography>
            </div>
          </td>

          <td className={classes}>
            <div className="flex justify-center px-4">
              <Typography color="blue-gray" className="textRight">
                {last_action === "admin" ? "ادمین" : last_action === "agent" ? "شما" : "کاربر"}
              </Typography>
            </div>
          </td>

          <td className={classes}>
            <div className="flex justify-center px-4">
              <Chip className="textRight" variant="ghost"
                    value={Dict(status)}
                    color={status === "agent_payed" || status === "person_payed" ? "cyan" : status === "new" ? "amber" : status === "settled" ? "teal" : "red"}/>
            </div>
          </td>

          <td className={classes}>
            <div className="flex flex-col justify-center px-4">
              <Typography color="blue-gray">
                {persianNumberFormat(updated_at.split(" ")[0])}
              </Typography>
              <Typography color="blue-gray">
                {persianNumberFormat(updated_at.split(" ")[1])}
              </Typography>

            </div>
          </td>

          <td className={classes}>
            <Tooltip content="ویرایش">
              <IconButton variant="text" className="text-align=right" onClick={() => {
                setSideCost(sideCosts[index]);
                setModalOpen(true);
                setStep("side_cost")
              }}>
                <PencilIcon className="h-4 w-4"/>
              </IconButton>
            </Tooltip>
          </td>
        </tr>);
      },)}
      </tbody>
    </table>
  </div>);
}